import { ContactRole, ContactRoleId } from "../../../services/organization.service";
import { SearchCriteriaService } from "../../../services/search/search-criteria/search.criteria.service";

const NO_ROLE_LABEL = "No Role";

export async function enrichOrgMemberRoleNames(members: ContactRole[]): Promise<void> {
    if (!members?.length) {
        return;
    }
    const rolesMissingName = members.map((member) => member.role).filter((role) => role && !role.itemName?.trim());
    if (!rolesMissingName.length) {
        return;
    }

    const catalog = await SearchCriteriaService.getOrganizationRoles(true, true);
    const roleIdToName = new Map<number, string>();
    for (const roleOption of catalog ?? []) {
        if (roleOption.itemId != null && roleOption.itemName) {
            roleIdToName.set(Number(roleOption.itemId), roleOption.itemName);
        }
    }

    for (const member of members) {
        const role = member.role;
        if (!role || role.itemName?.trim()) {
            continue;
        }
        if (role.itemId === ContactRoleId.None) {
            role.itemName = NO_ROLE_LABEL;
            continue;
        }
        const resolvedName = roleIdToName.get(role.itemId);
        if (resolvedName) {
            role.itemName = resolvedName;
        }
    }
}
